import { Button, Typography } from '@mui/material';
import { SuccessDialogConfig } from '../../stores/dialogStore';
import { BaseDialog } from './BaseDialog';

interface SuccessDialogProps {
  config: SuccessDialogConfig;
  onClose: () => void;
}

function SuccessDialog({ config, onClose }: SuccessDialogProps) {
  const handleActionClick = (actionOnClick: () => void) => {
    actionOnClick();
    onClose();
  };

  const dialogContent = (
    <>
      {config.message && (
        <Typography variant="body1" sx={{ mb: 2 }}>
          {config.message}
        </Typography>
      )}
      {config.content}
    </>
  );

  const dialogActions = config.actions ? (
    config.actions.map((action) => (
      <Button
        key={action.text}
        onClick={() => handleActionClick(action.onClick)}
        color={action.color || 'primary'}
        variant={action.variant || 'contained'}
      >
        {action.text}
      </Button>
    ))
  ) : (
    <Button onClick={onClose} color="primary" variant="contained">
      OK
    </Button>
  );

  return (
    <BaseDialog
      config={{ ...config, type: 'success' }}
      onClose={onClose}
      title={config.title}
      content={dialogContent}
      actions={dialogActions}
    />
  );
}

export default SuccessDialog;
